/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    risks: {
        menu: {
            index: 'عنوان منوی بازشو',
            create: 'ایجاد نام ماژول',
            list: 'لیست ماژول‌ها'
        },
        table_titles: {
            id: 'شناسه',
            title: 'عنوان',
            option: 'انتخاب',
            setting: 'ویرایش / حذف',
        },
        risk_evaluations_table: {
            id: 'شناسه',
            rule_category: 'دسته',
            rule_name: 'عنوان قانونی',
            rule_score: 'امتیاز',
            created_at: 'تاریخ ارزیابی',
        },

        edit: 'ویرایش ماژول'
    }
}
